import {IAuthenticationContext, withAuthentication} from "./authentication";
import {Link, Navigate, useNavigate} from "react-router-dom";
import React, {useState} from 'react';

import ContactMethodInput from "./contact_method_input";
import connect from "./assets/connect.png";
import {grpcAPI} from "./api";

interface Props extends IAuthenticationContext {

}

function SignInPage(props:Props) {
    const [contactMethod, setContactMethod] = useState<'phone' | 'email'>('phone');
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate()

    const signIn = (e:any) => {
        e.preventDefault()
        e.stopPropagation()
        if (isLoading){
            return;
        }
        const apiService = new grpcAPI();
        if (contactMethod === 'phone' && phoneNumber === "") {
            window.alert("Mobile Number can't be empty")
            return;
        }
        if (contactMethod === 'email' && emailAddress.trim() === "") {
            window.alert("Please enter your email address")
            return;
        }
        if (contactMethod === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailAddress)) {
            window.alert("Please enter a valid email address")
            return;
        }
        setIsLoading(true);

        const isEmailSignin = contactMethod === 'email';
        const requestBody = isEmailSignin
            ? { email: emailAddress }
            : { mobile: phoneNumber };

        apiService.hivTestAPIServiceSignin(requestBody).then((response)=>{
            if (response.data.success){
                if (isEmailSignin) {
                    localStorage.setItem("email", emailAddress);
                } else {
                    localStorage.setItem("mobile", phoneNumber);
                }
                localStorage.setItem("registrationMethod", contactMethod);
                localStorage.setItem("challengeCode", response.data.challengeCode ?? "");
                setIsLoading(false)
                navigate("/verification", {replace: true})
            } else {
                window.alert(response.data.errorMessage)
            }
        }).catch((reason)=>{
            window.alert("Unknown server error, please retry");
        }).finally(()=>{
            setIsLoading(false)
        })
    }

    if (props.authentication.authenticated) {
        return (<Navigate to="/"/>);
    }

    return (
        <div>
            <div className={"backgroundPrimary text-center pb-3"}>
                <div className={"container"}>
                    <div className={"py-4"}>
                        <img className={"rounded-top rounded-bottom mw-100 mx-auto"} src={connect} alt=""/>
                    </div>
                    <p className="text-start textPrimary">Welcome back! Sign in to access your account.</p>
                </div>
            </div>
            <div className={"container py-3 backgroundSecondary"}>
                <div className={"footText1"}>
                    <p>
                        Don't have an account? <Link className={"textLink textUnderline"} to={"/sign_up"}>Sign up for free</Link>
                    </p>
                </div>
                <ContactMethodInput
                    contactMethod={contactMethod}
                    onContactMethodChange={setContactMethod}
                    phoneNumber={phoneNumber}
                    onPhoneNumberChange={setPhoneNumber}
                    emailAddress={emailAddress}
                    onEmailAddressChange={setEmailAddress}
                />
            </div>
            <div className={"backgroundPrimary pt-3 pb-5"}>
                <div className={"container"}>
                    <div className={"container text-center"}>
                        <div className="d-grid mw-100 buttonPrimary rounded">
                            <button className="textButton btn" onClick={signIn}>
                                {!isLoading && <span>Sign In</span>}
                                {isLoading && <i className="fas fa-spinner fa-spin"/>}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withAuthentication(SignInPage);
